import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaCalendarAlt, FaPlus, FaHome, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import ConfigService from '../services/ConfigService';

const Navigation = () => {
  const location = useLocation();
  const { logout, isAdmin } = useAuth();
  const [serviceName, setServiceName] = useState('CartScheduler');

  useEffect(() => {
    const loadConfig = async () => {
      const config = await ConfigService.loadConfig();
      setServiceName(config.serviceName || 'CartScheduler');
    };
    loadConfig();
  }, []);

  const handleLogout = () => {
    if (window.confirm('Är du säker på att du vill logga ut?')) {
      logout();
    }
  };

  const navItems = [
    { path: '/', icon: FaHome, label: 'Hem' },
    { path: '/schedule', icon: FaCalendarAlt, label: 'Schema' },
    { path: '/add-booking', icon: FaPlus, label: 'Ny Bokning' },
  ];

  if (isAdmin) {
    navItems.push({ path: '/admin', icon: FaCog, label: 'Admin' });
  }

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-1">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold bg-gradient-to-r from-primary-600 to-primary-800 bg-clip-text text-transparent">
                {serviceName}
              </h1>
            </div>
          </div>
          
          <div className="flex items-center space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <Icon className="mr-2" />
                  <span className="hidden sm:inline">{item.label}</span>
                </Link>
              );
            })}
            
            <button
              onClick={handleLogout}
              className="flex items-center px-4 py-2 rounded-lg text-sm font-medium text-gray-600 hover:text-red-600 hover:bg-red-50 transition-all duration-200 ml-2"
            >
              <FaSignOutAlt className="mr-2" />
              <span className="hidden sm:inline">Logga ut</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

